<template>
  <v-dialog v-model="visible" persistent max-width="800px">
    <v-card>
      <v-card-title>
        <v-spacer></v-spacer>
        <v-icon large @click="$emit('closed')">mdi-close</v-icon>
      </v-card-title>
      <v-card-text>
        <v-container>
          <v-row>
            <v-col cols="12" sm="12" md="8">
              <h1 class="text-h5 font-weight-regular pb-4">
                {{ $t("users.deleteUser") }}
              </h1>
              <p class="py-5">
                {{ $t("users.deleteMessage") }}
              </p>
              <v-row>
                <v-col>
                  <label class="second-type-label">{{ $t("users.nameAlias") }}</label>
                  <p class="font-weight-medium">{{ user.alias }}</p>
                </v-col>
                <v-col>
                  <label class="second-type-label">{{ $t("users.email") }}</label>
                  <p class="font-weight-medium">{{ user.email }}</p>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
      <v-card-actions class="card-action-with-space">
        <v-spacer></v-spacer>
        <v-btn outlined :color="entityConfig.primaryColor" @click="$emit('closed')" class="v-btn-width-default">
          {{ $t("users.goBack") }}
        </v-btn>
        <v-btn dark depressed :color="entityConfig.primaryColor" :style="`color: ${entityConfig.secondaryColor}`" @click="$emit('confirmed', user)" class="v-btn-width-default">
          {{ $t("users.delete") }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: ["user", "visible"],
  data() {
    return {
      entityConfig: {},
      model: {
        alias: '',
        email: ''
      },
    };
  },
  mounted() {
    this.model.alias = this.user.alias;
    this.model.email = this.user.email;
    this.entityConfig = this.$store.state.entityConfig.config;
  },
};
</script>